export default "/images/ic-mapping.svg?ebe73200db5b30763573771b2cc21ac8";